import styled from 'styled-components';
import { devices } from '../../../juristec-ui/core/breakpoints';

export const ContractedPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  & .plan-header {
    margin: 0;
    margin-bottom: 5px;
  }

  @media ${devices.phoneL} {
    padding-left: 1rem;
  }
`;

export const PlanHeader = styled.div`
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  & h3 {
    margin: 0;
  }
  & > div {
    position: absolute;
    right: 0;
  }
`;

export const RowData = styled.tr<{ group?: number }>`
  /* min-height: 40px; */
  background-color: ${({ theme, group }) => (group === 0 ? theme.tableBackground : theme.containerOdd)};
  &:hover {
    background-color: ${({ theme }) => theme.containerHover};
  }
  &.plan-row-hover {
    background-color: ${({ theme }) => theme.containerHover};
  }
  & td {
    padding: 10px 5px;
  }
`;

export const ScrollContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  @media ${devices.phoneL} {
    overflow: hidden;
  }
`;

export const TableContainer = styled.table`
width: 100%;
border-spacing: 0;
border-radius: 1rem;
overflow: hidden;
`;

export const LabelContainer = styled.td`
  text-align: center;
  font-weight: bold;
  width: 60%;
`;

export const InfoContainer = styled.td`
  text-align: center;
`;

export const PriceContainer = styled.div`
  color: ${({ theme }) => theme.success};
  & .primary {
    font-size: 40px;
  }
  & .secondary {
    font-size: 32px
  }

  @media ${devices.phoneS} {
    & .primary {
    font-size: 32px;
  }
  & .secondary {
    font-size: 24px
  }
  }
  font-weight: bold;
`;
